import type { z } from 'zod'
import type {
  Erc721TokenTransfer,
  LowerHex,
  TransactionDecoded,
} from '../../../../types'
import { getAllValue } from './allValue'
import { checkValueIsArrayIn } from './arrayIn'
import type { erc721TransferPatternSchema } from './schema'

export const checkTransferIsMatchErc721Pattern = ({
  transfer,
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly transfer: Erc721TokenTransfer
  readonly schema: z.infer<typeof erc721TransferPatternSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): boolean => {
  // address
  if (
    schema.address !== undefined &&
    !checkValueIsArrayIn({
      value: transfer.address,
      schema: schema.address,
      transaction,
      relatedAddresses,
    })
  ) {
    return false
  }

  // from
  if (
    schema.from !== undefined &&
    !checkValueIsArrayIn({
      value: transfer.from,
      schema: schema.from,
      transaction,
      relatedAddresses,
    })
  ) {
    return false
  }

  // to
  if (
    schema.to !== undefined &&
    !checkValueIsArrayIn({
      value: transfer.to,
      schema: schema.to,
      transaction,
      relatedAddresses,
    })
  ) {
    return false
  }

  // id
  if (
    schema.id !== undefined &&
    getAllValue({
      schema: schema.id,
      transaction,
      relatedAddresses,
    }) !== transfer.tokenId.toString()
  ) {
    return false
  }

  return true
}
